import React, { useState, FC, useEffect } from "react";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption } from "@/components/YhFormBox/Types";
import { RouterParamType } from "@/model/navModel";
import { useDtpDetailModel } from "../dtpDetailModel";
import { customerService } from "@/views/base/customer/customerService";
import { useGlobalModel } from "@/model/globalModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { salesService } from "@/views/sales/salesService";
import moment from "moment";
import { enquiryService } from "../../../dtpService";

export const FormBox: FC<RouterParamType> = ({ id, mode, formRef }) => {
    const {
        addFormVal,
        editFormVal,
        currency,
        updateFormVal,
        updateList
    } = useDtpDetailModel(({ addFormVal, editFormVal, currency }) => [addFormVal, editFormVal, currency]);

    const { fetchCustomerList, fetchSalesList, beShopDs } = useGlobalModel(({ beShopDs }) => [beShopDs]);
    const { getSelectedDictOne, getTreeNodeName } = useDictModel(() => []);

    const formVal = mode === "edit" ? editFormVal : addFormVal;

    //回显选中客户带出来的数据
    const getCustomer = async (id: string) => {
        let { retData } = await customerService.one(id);
        let data = {
            customerCode: retData.code,
            customerName: retData.name,
            phone: retData.phone,
            contact: retData.contact,
        }
        updateFormVal(mode, data);
    }

    //客户选中
    const customerChange = (value: string, option: ISelectOption) => {
        if (option && option.id) {
            getCustomer(option.id as string)
        }
    }


    //     amount: 1
    // code: "YYCY-NOR-2201"
    // createTime: "2022-05-24T21:41:52"
    // createUser: "陈彦晓"
    // customerCode: "CUS-M-00007825"
    // customsCode: "8481803990"
    // deleteFlag: 0
    // id: "1529095337396088833"
    // inventoryNum: 0
    // materialCode: "HB60002"
    // materialEname: "Proportional valve"
    // materialName: "控制阀"
    // model: "HB60002"
    // num: 1
    // orderNum: 0
    // price: 1
    // replaceCode: "HB60002"
    // saleAmount: 0
    // salePrice: 0
    // shopCode: "SHOP-M-00000032"
    // status: "sales.pend-ship"
    // supplierCode: "SUP-M-00000631"
    // tradeAmount: 0
    // tradePrice: 0
    // typeCode: "material-type.fast.b3"
    // typeName: "B3-法士特"
    // updateTime: "2022-05-24T21:50:47"
    const getSale = async (id: string) => {
        debugger
        let { retData: { details, detailsAdd, ...params } } = await salesService.one(id);
        //查物流进程
        let { retData: logData } = await salesService.oneLog(params.code);
        //查出运的信息
        let { retData: shipmentInfo } = await enquiryService.findBySaleCodeTotal(params.code);
        let data = {
            supplierCode: params.bentityCode,
            supplierName: params.bentityName,
            customerCode: params.customerCode,
            customerName: params.customerName,
            insure: params.premium,    //带出保费
            countryTrade: params.countryCode,  //带出贸易国别discharge
            destinationCountry: params.countryCode,  //带出贸易国别discharge
            dischargingPort: params.discharge, //带出卸货港 
            portDeparture: params.shipment,  //带出装货港
            transactionType: params.clause,  //带出贸易条款
            labelNote: params.shippingMark,  //带出唛头
            invoiceNumber: params.code, // 带出外贸合同号
            num: shipmentInfo?.number, // 带出商品件数,
            roughWeight: shipmentInfo?.grossWeightTotal, // 总毛重,
            suttle: shipmentInfo?.netWeightTotal, // 总净重,
            declareTime: logData?.declareTime ? moment(logData.declareTime) : null,//报关日期
            invoiceTime: params?.offerTime ? moment(params.offerTime) : null,//签约日期
            freight: detailsAdd?.find(item => (item.name ?? "").indexOf("运费") > -1)?.amount, // 带出运费
            relevanceOrderId: params.relevanceOrderId,
            saleCode:params.code,
            saleRealCode:params.realCode
        }
        updateFormVal(mode, data);
        updateList(mode, details?.map(item => {
            let { id, ...i } = item;
            return ({
                ...i,
                key: id ?? "",
                price: item.tradePrice,
                amount: item.tradeAmount,
                currency: getTreeNodeName(params.currencyCode),
            })
        }) ?? [])
    }

    const saleCodeChange = (value: string, option: ISelectOption) => {
        debugger
        if (option && option.id) {
            getSale(option.id as string)
        }
    }

    //表单change
    const onChange = (changedValues: { [key: string]: any }, values: any) => {
        updateFormVal(mode, values);
    }

    //出口商
    const bentityChange = (value: string, option: ISelectOption) => {
        option && updateFormVal(mode, { supplierCode: option.value, supplierName: option.label });
    }

    const baseFormItem: IYhFormItemsBox = {
        title: "基础信息",
        style: { padding: "10px 0 0 0", marginBottom: "10px" },
        contentClass: "pr-2",
        disabled:formVal.status==='clearance-status.effect',
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "预录编号",
                fieldName: "prescoCode",
                
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "海关编号",
                fieldName: "customsCode",
                
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备案号",
                fieldName: "recordVarchar",
            }, 
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "外贸合同号(配合)",
                fieldName: "saleCode",
                hidden:true
            },{
                type: FormItemTypeEnum.AsyncSelect,
                fieldLabel: "外贸合同号",
                fieldName: "saleRealCode",
                selectfetchList: fetchSalesList,
                onSelectChange: saleCodeChange,
                rules: [{ required: true, message: "请选择外贸合同号" }],
                // disable: formVal.status === 'clearance-status.effect'
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "境内发货人",
                fieldName: "supplierCode",
                options: beShopDs,
                onSelectChange: bentityChange,
                rules: [{ required: true, message: "请选择境内发货人" }],
            }, {
                type: FormItemTypeEnum.AsyncSelect,
                fieldLabel: "境外收货人",
                fieldName: "customerCode",
                onSelectChange: customerChange,
                placeholder: "境外收货人",
                rules: [{ required: true, message: "请输入境外收货人" }],
                selectfetchList: fetchCustomerList,
                defaultQuery: formVal.customerName
                
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "出境关别",
                fieldName: "exitType",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "运输方式",
                fieldName: "shipmentType",
                options: getSelectedDictOne(DictCodeEnmu.TRANSPORT_MODE),
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "出口日期",
                fieldName: "departureTime",
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "申报日期",
                fieldName: "declareTime",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "监管方式",
                fieldName: "supervisionMethod",
                options: getSelectedDictOne(DictCodeEnmu.REGULATION_PATTERN),
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "征免性质",
                fieldName: "exemptionType",
                options: getSelectedDictOne(DictCodeEnmu.EXEMPTION_NATURE),
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "许可证号",
                fieldName: "licenseKey",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "提运单号",
                fieldName: "deliveryNumber",
                rules: [{ required: true, message: "请输入提运单号" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "贸易国(地区)",
                fieldName: "countryTrade",
                options: getSelectedDictOne(DictCodeEnmu.COUNTRY),
                rules: [{ required: true, message: "请选择贸易国" }],
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "运抵国(地区)",
                fieldName: "destinationCountry",
                options: getSelectedDictOne(DictCodeEnmu.COUNTRY),
                rules: [{ required: true, message: "请选择运抵国" }],
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "指运港",
                fieldName: "dischargingPort",
                options: getSelectedDictOne(DictCodeEnmu.DISCHARTGE_PORT),
                rules: [{ required: true, message: "请选择指运港" }],
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "离境口岸(地区)",
                fieldName: "portDeparture",
                options: getSelectedDictOne(DictCodeEnmu.LOAD_PORT),
                rules: [{ required: true, message: "请输入离境口岸" }],
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: <span style={{ fontSize: "12px", whiteSpace: "normal" }}>运输工具名称及航次号</span>,
                fieldName: "voyageNumber",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "成交方式",
                fieldName: "transactionType",
                options: getSelectedDictOne(DictCodeEnmu.TRADE_CLAUSE),
                rules: [{ required: true, message: "请输入成交方式" }],
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "包装种类",
                fieldName: "packageType",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "件数",
                fieldName: "num",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "毛重(千克)",
                fieldName: "roughWeight",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "净重(千克)",
                fieldName: "suttle",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "总体积",
                fieldName: "volume",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "运费",
                fieldName: "freight",
                prefix: currency,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "保费",
                fieldName: "premium",
                prefix: currency,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "杂费",
                fieldName: "incidentals",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: <span style={{ fontSize: "12px", whiteSpace: "normal" }}>随附单证及编号</span>,
                fieldName: "documentsNum",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: <span style={{ fontSize: "12px", whiteSpace: "normal" }}>标记唛码及备注</span>,
                fieldName: "labelNote",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "特殊关系确认",
                fieldName: "relationshipAffirm",
                options: [{ label: "是", value: "是" }, { label: "否", value: "否" }],
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "价格影响确认",
                fieldName: "priceAffirm",
                options: [{ label: "是", value: "是" }, { label: "否", value: "否" }],
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: <span style={{ fontSize: "12px", whiteSpace: "normal" }}>支付特许权使用费确认</span>,
                fieldName: "payAffirm",
                options: [{ label: "是", value: "是" }, { label: "否", value: "否" }],
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "自报自缴",
                fieldName: "declareType",
                options: [{ label: "是", value: "是" }, { label: "否", value: "否" }],
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发票号",
                fieldName: "invoiceNumber",
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "发票日期",
                fieldName: "invoiceTime",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                placeholder: "请填写英文的金额总计",
                fieldName: "note",
                labelCol: { span: 4 },
                span: 12,
            },
            //带出
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户名称",
                fieldName: "customerName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户名称",
                fieldName: "supplierName",
                hidden: true
            },
        ]
    };

    const stockEntryFromConfig: IYhFormBox = {
        formRef,
        labelCol: { span: 8 },
        labelAlign: "right",
        formValues: formVal,
        // disabled: formVal.status === 'clearance-status.effect' ? true : false,
        onChange,
        boxs: [baseFormItem]
    }


    return (
        <YhFormBox {...stockEntryFromConfig} />
    )
}